// #useAuthUpdated

import {
  Button,
  Snackbar,
  FormControlLabel,
  Switch,
  Grid,
  Typography,
} from "@material-ui/core";
import { PersonAdd } from "@material-ui/icons";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
// import Select from "react-select";
// import { selectFieldProps } from "../shared/constants";
import DealersDownstream from "./subdealers/DealersDownstream";

/**
 * SubDealerManage component renders the content for the Manage Teams page for subdealers.
 * It displays a list of dealer levels below the current dealer, and allows users to create new dealers or view/search all dealers.
 * It also displays a button to view all approvals.
 *
 * @component
 * @example
 * <SubDealerManage />
 *
 * @function
 * @name SubDealerManage
 *
 * @description
 * This component uses several hooks:
 * - `useHistory` from `react-router-dom` to navigate back to the settings page.
 * - `useState` to manage component state for dialog open/close, level name, level, loading, and error.
 * - `useCompany` custom hook to get dealer levels and upsertDealerLevel function.
 *
 * @typedef {object} DealerLevel
 * @property {string} id - The unique identifier of the dealer level.
 * @property {string} level_name - The name of the dealer level.
 *
 * @typedef {object} UpsertDealerLevelParams
 * @property {number} level - The level number.
 *
 * @async
 * @function handleSubmit
 * @description Handles the submission of the new dealer level form.
 * It sets the loading state, calls the upsertDealerLevel function, and handles any errors.
 *
 * @returns {Promise<void>}
 */
export default function SubDealerManage() {
  const [snackbarIsOpen, setSnackbarIsOpen] = useState(false);
  const { currentUser } = useAuth();
  const [pendingFilter, setPendingFilter] = useState(false);
  const history = useHistory();

  const togglePendingFilter = () => setPendingFilter(prev => !prev);

  if (!currentUser.is_admin && !currentUser.is_leader) {
    return <div>You don't have access to this page</div>;
  }

  return (
    <div>
      <br />
      <Grid
        container
        direction="column"
        spacing={2}
        justifyContent="flex-start"
      >
        <Grid item>
          <Typography variant="h4">Manage Teams</Typography>
        </Grid>
        <Grid container item direction="row" justifyContent="space-between">
          <Grid item>
            <Button
              variant="outlined"
              style={{ margin: "0 1rem 1rem 0" }}
              startIcon={<PersonAdd />}
              color="primary"
              onClick={() => history.push("/users/create")}
            >
              Create User
            </Button>
          </Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Switch
                  onChange={togglePendingFilter}
                  checked={pendingFilter}
                />
              }
              label="View Pending Users"
            />
          </Grid>
        </Grid>
        <Grid item>
          <DealersDownstream pendingOnly={pendingFilter} />
        </Grid>
      </Grid>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={snackbarIsOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarIsOpen(false)}
        message="Person Added!"
      />
    </div>
  );
}
